import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

/**
 * Pendaftaran service worker (PWA / mode offline).
 *
 * Hanya di produksi. Di mode pengembangan `vite dev` menyajikan modul sendiri,
 * jadi SW akan menelan hot-reload dan membuat setiap perubahan source tampak
 * seperti bug - Development-tools service worker jauh lebih lambat dik/debug.
 *
 * Kegagalan pendaftaran tidak boleh menggagalkan boot: aplikasi tetap berfungsi
 * penuh tanpa SW, hanya tanpa mode offline.
 */
function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return
  if (!import.meta.env.PROD) return

  let registration: Promise<ServiceWorkerRegistration>
  try {
    registration = navigator.serviceWorker.register('/sw.js', { scope: '/' })
  } catch (error) {
    console.warn('[pwa] service worker gagal didaftarkan', error)
    return
  }
  registration.catch((error) => console.warn('[pwa] gagal', error))

  // Worker versi baru selesai diunduh dan sedang menunggu. Karena konten kamus
  // berubah, menunda berarti pengguna membaca data versi lama - jadi langsung
  // aktifkan worker itu lalu muat ulang.
  navigator.serviceWorker.addEventListener('updatefound', () => {
    registration.then((reg) => {
      const worker = reg.installing
      if (!worker) return
      worker.addEventListener('statechange', () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) {
          worker.postMessage({ type: 'SKIP_WAITING' })
          window.location.reload()
        }
      })
    })
  })
}

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, options?: { timeout: number }) => void
}

if (typeof window !== 'undefined') {
  const idle = (window as IdleWindow).requestIdleCallback
  if (typeof idle === 'function') {
    // Tunda sampai browser menganggur: pendaftaran SW bukan hal yang perlu
    // berebut dengan render pertama.
    idle(() => registerServiceWorker(), { timeout: 3000 })
  } else {
    window.addEventListener('load', registerServiceWorker, { once: true })
  }
}

const container = document.getElementById('root')
if (!container) throw new Error('#root tidak ditemukan di index.html')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
